// 对齐 galaxy：统一生成前端对外可用的 server base url
// neocloud 没有 getServerUrl，这里补一个最小实现：
// - 优先读环境变量（若项目配置了）
// - 否则回退到当前站点 origin

export function getServerUrl() {
  const env =
    (typeof process !== "undefined" &&
      process &&
      process.env &&
      (process.env.VUE_APP_SERVER_URL ||
        process.env.VUE_APP_BASE_URL ||
        process.env.VUE_APP_API_BASE_URL)) ||
    "";

  if (env) return String(env).replace(/\/$/, "");
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    return window.location.origin;
  }
  return "";
}


